import styled from 'styled-components';

export const StyledLogo = styled.div`
  flex: none;
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  cursor: pointer;
  a {
    padding: 0.9rem 0;
    display: inline-block;
  }
`;
